/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Sharp_Owl_ErrorInputs */

const en_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're already using this address for Brave premium. Please enter a new address to proceed.`)
};

const id_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda sudah menggunakan alamat ini untuk Brave premium. Silakan masukkan alamat baru untuk melanjutkan.`)
};

const ms_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda sudah menggunakan alamat ini untuk Brave premium. Sila masukkan alamat baharu untuk meneruskan.`)
};

const ca_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja estàs utilitzant aquesta adreça per Brave Premium. Si us plau, introdueix una nova adreça per continuar.`)
};

const cs_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuto adresu již používáte pro Brave premium. Pro pokračování zadejte novou adresu.`)
};

const da_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bruger allerede denne adresse til Brave Premium. Indtast en ny adresse for at fortsætte.`)
};

const de_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie verwenden diese Adresse bereits für Brave Premium. Bitte geben Sie eine neue Adresse ein, um fortzufahren.`)
};

const et_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas kasutate seda aadressi juba Brave premium'i jaoks. Jätkamiseks sisestage uus aadress.`)
};

const es_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya estás usando esta dirección para Brave premium. Por favor, introduce una nueva dirección para continuar.`)
};

const fr_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous utilisez déjà cette adresse pour Brave Premium. Saisissez une autre adresse pour continuer.`)
};

const hr_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Već koristite ovu adresu za Brave premium. Molimo unesite novu adresu za nastavak.`)
};

const it_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai già usando questo indirizzo per Brave premium. Inserisci un nuovo indirizzo per procedere.`)
};

const lv_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs jau izmantojat šo adresi Brave Premium. Lūdzu, ievadiet jaunu adresi, lai turpinātu.`)
};

const lt_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs jau naudojate šį adresą Brave Premium. Prašome įvesti naują adresą, kad tęstumėte.`)
};

const hu_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Már használja ezt a címet a Brave prémiumhoz. Kérjük, adjon meg egy új címet a folytatáshoz.`)
};

const nl_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je gebruikt dit adres al voor Brave premium. Voer een nieuw adres in om door te gaan.`)
};

const nb_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bruker allerede denne adressen i Brave Premium. Du må skrive inn en ny adresse for å gå videre.`)
};

const pl_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Używasz już tego adresu dla Brave premium. Podaj nowy adres, aby kontynuować.`)
};

const pt_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você já está usando este endereço para o Brave Premium. Por favor, insira um novo endereço para prosseguir.`)
};

const ro_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folosiți deja această adresă pentru Brave premium. Vă rugăm să introduceți o nouă adresă pentru a continua.`)
};

const sk_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Túto adresu už používate pre Brave premium. Zadajte novú adresu, aby ste mohli pokračovať.`)
};

const sl_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta naslov že uporabljate za Brave premium. Vnesite nov naslov za nadaljevanje.`)
};

const fi_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käytät jo tätä osoitetta Brave premiumille. Syötä uusi osoite, jotta voit jatkaa.`)
};

const sv_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du använder redan denna adress för Brave premium. Vänligen ange en ny adress för att fortsätta.`)
};

const vi_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đang sử dụng địa chỉ này cho Brave premium. Vui lòng nhập một địa chỉ mới để tiếp tục.`)
};

const tr_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu adresi zaten Brave premium için kullanıyorsunuz. Devam etmek için lütfen yeni bir adres girin.`)
};

const el_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χρησιμοποιείτε ήδη αυτή τη διεύθυνση για το Brave premium. Παρακαλούμε εισάγετε μια νέα διεύθυνση για να προχωρήσετε.`)
};

const bg_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вие вече използвате този адрес за Brave premium. Моля, въведете нов адрес, за да продължите.`)
};

const ru_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уже используете этот адрес для Brave Premium. Введите новый адрес, чтобы продолжить.`)
};

const sr_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Већ користите ову адресу за Brave премиум. Унесите нову адресу за наставак.`)
};

const uk_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви вже використовуєте цю адресу для Brave Premium. Будь ласка, введіть нову адресу, щоб продовжити.`)
};

const ka_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენ უკვე იყენებთ ამ მისამართს Brave Premium-ისთვის. გთხოვთ შეიყვანოთ ახალი მისამართი პროცესის გასაგრძელებლად.`)
};

const hi_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप पहले से ही इस पते का प्रयोग Brave प्रीमियम के लिए कर रहे हैं। कृपया आगे बढ़ने के लिए एक नया पता दर्ज करें।`)
};

const th_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณกำลังใช้ที่อยู่นี้สำหรับ Brave premium อยู่แล้ว โปรดป้อนที่อยู่อื่นเพื่อดำเนินการต่อ`)
};

const ko_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 주소는 이미 Brave 프리미엄에서 사용 중입니다. 계속하려면 새 주소를 입력하세요.`)
};

const zh_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您已经在使用此地址访问 Brave premium。请输入新的地址以继续。`)
};

const zh_tw_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您已使用此地址註冊 Brave 高級版服務。請輸入新地址以繼續操作。`)
};

const ja_wise_sharp_owl_error = /** @type {(inputs: Wise_Sharp_Owl_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアドレスは既にBraveプレミアムで使用されています。続行するには新しいアドレスを入力してください。`)
};

/**
* | output |
* | --- |
* | "You're already using this address for Brave premium. Please enter a new address to proceed." |
*
* @param {Wise_Sharp_Owl_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const wise_sharp_owl_error = /** @type {((inputs?: Wise_Sharp_Owl_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Sharp_Owl_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wise_sharp_owl_error(inputs)
	if (locale === "ms") return ms_wise_sharp_owl_error(inputs)
	if (locale === "ca") return ca_wise_sharp_owl_error(inputs)
	if (locale === "cs") return cs_wise_sharp_owl_error(inputs)
	if (locale === "da") return da_wise_sharp_owl_error(inputs)
	if (locale === "de") return de_wise_sharp_owl_error(inputs)
	if (locale === "et") return et_wise_sharp_owl_error(inputs)
	if (locale === "es") return es_wise_sharp_owl_error(inputs)
	if (locale === "fr") return fr_wise_sharp_owl_error(inputs)
	if (locale === "hr") return hr_wise_sharp_owl_error(inputs)
	if (locale === "it") return it_wise_sharp_owl_error(inputs)
	if (locale === "lv") return lv_wise_sharp_owl_error(inputs)
	if (locale === "lt") return lt_wise_sharp_owl_error(inputs)
	if (locale === "hu") return hu_wise_sharp_owl_error(inputs)
	if (locale === "nl") return nl_wise_sharp_owl_error(inputs)
	if (locale === "nb") return nb_wise_sharp_owl_error(inputs)
	if (locale === "pl") return pl_wise_sharp_owl_error(inputs)
	if (locale === "pt") return pt_wise_sharp_owl_error(inputs)
	if (locale === "ro") return ro_wise_sharp_owl_error(inputs)
	if (locale === "sk") return sk_wise_sharp_owl_error(inputs)
	if (locale === "sl") return sl_wise_sharp_owl_error(inputs)
	if (locale === "fi") return fi_wise_sharp_owl_error(inputs)
	if (locale === "sv") return sv_wise_sharp_owl_error(inputs)
	if (locale === "vi") return vi_wise_sharp_owl_error(inputs)
	if (locale === "tr") return tr_wise_sharp_owl_error(inputs)
	if (locale === "el") return el_wise_sharp_owl_error(inputs)
	if (locale === "bg") return bg_wise_sharp_owl_error(inputs)
	if (locale === "ru") return ru_wise_sharp_owl_error(inputs)
	if (locale === "sr") return sr_wise_sharp_owl_error(inputs)
	if (locale === "uk") return uk_wise_sharp_owl_error(inputs)
	if (locale === "ka") return ka_wise_sharp_owl_error(inputs)
	if (locale === "hi") return hi_wise_sharp_owl_error(inputs)
	if (locale === "th") return th_wise_sharp_owl_error(inputs)
	if (locale === "ko") return ko_wise_sharp_owl_error(inputs)
	if (locale === "zh") return zh_wise_sharp_owl_error(inputs)
	if (locale === "zh-tw") return zh_tw_wise_sharp_owl_error(inputs)
	if (locale === "ja") return ja_wise_sharp_owl_error(inputs)
	return en_wise_sharp_owl_error(inputs)
});